import classnames from 'classnames';
import React, { memo, useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { PCStoreJsBridge } from '../nativeapi';
import { cacheKeys, localKeys } from '../constants/storageKeys';
import styles from './Operation.module.less';
import './animation.css';
import {
  setDownloadVisible,
  setPinPopVisible,
  setPinPopCloseVisible,
  setOperationMenuVisible,
  setNewVersionInfo,
  setMaximize,
  setDownloadPathVisible,
  setAboutVisible,
  setPhoneVisible,
  setCheckUpdateVisible,
  setReleaseNotesVisible,
  setUserFeedbackVisible,
  setShareVisible,
  setMessageVisible,
  setMessageActiveTab,
  setCleanToDStoreVisible,
  setTrayDialogVisible,
} from '../actions/layout';
import { APP_VERSION, APP_VERSION_D, CONTEXT, UPDATE_USER_LPS } from '../config';
import { DOWNLOAD_FINISHED, DOWNLOAD_ING } from '../constants/softstatus';

import { logging } from '../actions/log';
import { getMessageHot, emptyHot } from '../actions/message';
import { logNative, createAxios, localGetItem, localSetItem } from '../utils/utils';
import { SIM_DOWNLOAD_ING } from '../constants/asimstatus';
import User from './User';
import DownloadAnimate from './OperationMenu/DownloadAnimate';
import useLoginStatus from '../utils/hooks/useLoginStatus';

const selectDownloadVisible = createSelector(
  state => state.layout,
  layout => layout.downloadVisible,
);

const selectOperationMenuVisible = createSelector(
  state => state.layout,
  layout => layout.OperationMenuVisible,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectNewVersionInfo = createSelector(
  state => state.layout,
  Layout => Layout.newVersionInfo,
);

const selectSIMStatus = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.status,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectTopImgVideoVisible = createSelector(
  state => state.layout,
  layout => layout.topImgVideo,
);
const selectIsMaximize = createSelector(
  state => state.layout,
  layout => layout.isMaximize,
);

const selectMessage = createSelector(
  state => state.message,
  message => ({
    hot: message.hot,
  }),
);

const selectMessageVisible = createSelector(
  state => state.layout,
  layout => layout.messageVisible,
);

export default memo(() => {
  const history = useHistory();
  const location = useLocation();
  const downVisible = useSelector(selectDownloadVisible);
  const OperationMenuVisible = useSelector(selectOperationMenuVisible);
  const softs = useSelector(selectDownloadSofts); // 用于判断是否展示正在下載的数目
  const newVersionInfo = useSelector(selectNewVersionInfo);
  const SIMStatus = useSelector(selectSIMStatus); // 模拟器当前状态，用于判断是否弹出弹框
  const dispatch = useDispatch();
  const [showZoom, setShowZoom] = useState(false);
  const [isShowHot, setIsShowHot] = useState(false); // 用户判断是否展示小红点
  const userInfo = useSelector(selectUserInfo);
  const topImgVideo = useSelector(selectTopImgVideoVisible); // 头部图片视频
  const isMaximize = useSelector(selectIsMaximize);
  const { hot } = useSelector(selectMessage);
  const messageVisible = useSelector(selectMessageVisible);
  const [loginStatus, setLoginStatus] = useState(false);
  const timer = useRef(null);
  const [orderTag, setOrderTag] = useState(false);
  const loginStatu = useLoginStatus();

  useEffect(() => {
    sessionStorage.setItem('PCStoreIsMaximize', isMaximize ? 1 : 0);
  }, [isMaximize]);

  useEffect(() => {
    const login_status = window.CallNativeMethod('get_login_status');
    if (!(login_status !== '1' || !userInfo.st)) {
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, [userInfo]);
  /**
   * 初始化、和每次检查更新组件关闭时对比当前是否是最新版本独立包
   * 更新是否需要展示小红点
   */
  useEffect(() => {
    const releaseNotesVersion = localStorage.getItem(cacheKeys.RELEASE_NOTES_VERSION);
    // 获取startInfo
    const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
    const startInfos = JSON.parse(startInfoStr || '{}');

    // eslint-disable-next-line camelcase
    const login_status = window.CallNativeMethod && window.CallNativeMethod('get_login_status');

    if (
      (startInfos && startInfos.isDStore && newVersionInfo && newVersionInfo.versionName) ||
      releaseNotesVersion !== (startInfos.isDStore ? APP_VERSION_D : APP_VERSION) ||
      // eslint-disable-next-line camelcase
      (!(login_status !== '1' || !userInfo.st) && hot && hot[3] === '1')
    ) {
      setIsShowHot(true);
    } else {
      setIsShowHot(false);
    }
  }, [newVersionInfo, OperationMenuVisible, userInfo, hot]);

  // hot 1:评论与回复 2：收藏和点赞 4：邀请回答 5：系统消息
  useEffect(() => {
    if (hot && [hot[1], hot[2], hot[4], hot[5]].indexOf('1') > -1) {
      PCStoreJsBridge.storeTrayRedPointChange(1).catch(err => {
        logNative(`小红点同步接口调用失败`);
      });
    } else if (hot && hot[1] === '0' && hot[2] === '0' && hot[4] === '0' && hot[5] === '0') {
      PCStoreJsBridge.storeTrayRedPointChange(0).catch(err => {
        logNative(`小红点同步接口调用失败`);
      });
    }
    if (!loginStatu && Object.keys(hot)?.length !== 0) {
      dispatch(emptyHot());
      PCStoreJsBridge.storeTrayRedPointChange(0).catch(err => {
        logNative(`小红点同步接口调用失败`);
      });
    }
  }, [hot, loginStatu]);

  useEffect(() => {
    // eslint-disable-next-line camelcase
    const login_status = window.CallNativeMethod && window.CallNativeMethod('get_login_status');
    // eslint-disable-next-line camelcase
    if (!(login_status !== '1' || !userInfo.st) && !messageVisible) {
      // 立即执行一次
      dispatch(getMessageHot());
      if (timer && timer.current) {
        clearInterval(timer.current);
      }
      // 5分钟取一次小红点
      timer.current = setInterval(() => {
        dispatch(getMessageHot());
      }, 1000 * 60 * 5);
    } else if (timer && timer.current && messageVisible) {
      clearInterval(timer.current);
      timer.current = null;
    }
  }, [userInfo, messageVisible]);

  // 判断订单中心气泡的弹出方式
  useEffect(() => {
    const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
    const startInfos = JSON.parse(startInfoStr || '{}');
    const localVersion = localGetItem('ORDER_TAG_VERSION_NUM');
    if (localVersion === '') {
      setOrderTag(true);
      if (startInfos && startInfos?.ClientVersion) {
        // setOrderTag(true);
        localSetItem('ORDER_TAG_VERSION_NUM', startInfos.ClientVersion);
      }
    }
    // if (!localGetItem('ORDER_TAG_88')) {
    //   localSetItem('ORDER_TAG_88', 1);
    //   setOrderTag(false);
    // } else if (
    //   localGetItem('ORDER_TAG_88') === '1' &&
    //   localVersion !== '' &&
    //   startInfos?.ClientVersion &&
    //   localVersion !== startInfos.ClientVersion
    // ) {
    //   localSetItem('ORDER_TAG_88', 2);
    //   setOrderTag(true);
    // } else if (localGetItem('ORDER_TAG_88') === '2') {
    //   setOrderTag(true);
    //   localSetItem('ORDER_TAG_88', 3);
    // }
  }, [localStorage.getItem(cacheKeys.START_INFO)]);

  useEffect(() => {
    // 获取startInfo
    const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
    const startInfos = JSON.parse(startInfoStr || '{}');
    if (startInfos.isDStore) {
      PCStoreJsBridge.isNeedUpdatePCStore().then(
        res => {
          if (res && res.versionName) {
            dispatch(setNewVersionInfo(res));
          } else {
            dispatch(setNewVersionInfo(res || {}));
          }
        },
        error => {
          logNative('检测版本更新失败', error);
          dispatch(setNewVersionInfo({ error: true }));
        },
      );
    }
  }, []);

  /**
   * 初始化信息
   */
  useEffect(() => {
    if (softs.length > 0) {
      setShowZoom(true);
    }
  }, [softs.length]);

  const toggleDownload = useCallback(
    ev => {
      // 点击 下载管理 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'D_Manage',
          label: '',
          param2: {
            source: 'HomePage',
          },
        }),
      );
      dispatch(setDownloadVisible(!downVisible));
      dispatch(setOperationMenuVisible(false));
      ev.stopPropagation();
    },
    [dispatch, downVisible],
  );
  const handleMenu = useCallback(
    ev => {
      // 点击 menu 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'OperationMenu',
          label: '',
          param2: {
            source: 'HomePage',
          },
        }),
      );
      dispatch(setOperationMenuVisible(!OperationMenuVisible));
      dispatch(setDownloadVisible(false));
      ev.stopPropagation();
    },
    [dispatch, OperationMenuVisible],
  );

  const closeOtherDialog = useCallback(
    dialog => {
      dispatch(setOperationMenuVisible(false));
      dispatch(setDownloadPathVisible(dialog === 'Setting'));
      dispatch(setAboutVisible(dialog === 'About'));
      dispatch(setPhoneVisible(dialog === 'Phone'));
      dispatch(setCheckUpdateVisible(dialog === 'CheckUpdate'));
      dispatch(setReleaseNotesVisible(dialog === 'ReleaseNotes'));
      dispatch(setUserFeedbackVisible(dialog === 'userFeedback'));
      dispatch(setShareVisible(dialog === 'Share'));
      dispatch(setMessageVisible(dialog === 'Message'));
    },
    [dispatch],
  );

  const handleMessage = useCallback(
    ev => {
      // 点击 消息盒子
      dispatch(
        logging({
          category: 'C',
          action: 'Message',
          label: '',
          param2: {
            source: 'HomePage',
            pageUrl: location.pathname,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('Message');
      if (hot[1] === '1') {
        dispatch(setMessageActiveTab('comment'));
        return;
      }
      if (hot[2] === '1') {
        dispatch(setMessageActiveTab('collect'));
        return;
      }
      if (hot[4] === '1') {
        dispatch(setMessageActiveTab('invite'));
        return;
      }
      if (hot[5] === '1') {
        dispatch(setMessageActiveTab('sys'));
        return;
      }
      dispatch(setMessageActiveTab('comment'));
    },
    [closeOtherDialog, dispatch, hot],
  );

  const handleMiddle = useCallback(() => {
    // 点击 最大窗口 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Mid',
        label: '',
        param2: {
          source: 'HomePage',
          pageUrl: location.pathname,
        },
      }),
    );

    dispatch(setMaximize({ isMaximize: false }));
    PCStoreJsBridge.middleWindow();
  }, [location]);

  const handleMaximize = useCallback(() => {
    // 点击 最大窗口 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Max',
        label: '',
        param2: {
          source: 'HomePage',
          pageUrl: location.pathname,
        },
      }),
    );
    dispatch(setMaximize({ isMaximize: true }));
    PCStoreJsBridge.maximizeWindow();
  }, [location]);

  const handleMini = useCallback(() => {
    // 点击 最小窗口 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Minimize',
        label: '',
        param2: {
          source: 'HomePage',
        },
      }),
    );
    PCStoreJsBridge.minimizeWindow();
  }, []);

  const updateUserLpsInfo = useCallback(async () => {
    const userToken = localStorage.getItem(cacheKeys.X_LESYNC_TOKEN) || '';
    if (userInfo && userInfo.st) {
      const param = {
        apptype: 'lenovoAppStore',
        lpsust: userInfo.st,
        realm: 'pcassistant.lenovo.com',
      };
      const axios = await createAxios();
      axios.post(UPDATE_USER_LPS, param).then(res => {
        logNative('8.0版本关闭商店前，更新获取一次lpsust  结果：', res);
      });
    }
  }, [userInfo]);

  const closeWindowFunc = () => {
    setTimeout(() => {
      PCStoreJsBridge.closeWindow();
    }, 100);
  };

  const handleClose = useCallback(() => {
    const downloadSofts = [];
    const installSofts = [];

    updateUserLpsInfo(userInfo);
    // 点击 关闭窗口 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Close',
        label: '',
        param2: {
          source: 'HomePage',
          downloadSofts: downloadSofts.join(','),
          installSofts: installSofts.join(','),
          openTime: window.PC_STORE_START_HTML_LOAD_END,
          closeTime: +new Date(),
          openTimeDiff: +new Date() - window.PC_STORE_START_HTML_LOAD_END,
        },
      }),
    );

    // 判断是否为集成包，是集成包就弹框洗成独立包
    const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
    const cleanToDStoreTime = parseInt(localGetItem(cacheKeys.SHOW_CLEAN_TO_DSTORE_TIME) || '0');
    // 15天弹出一次
    let diffTime = 1000 * 60 * 60 * 24 * 15;
    if (!startInfo.isDStore && +new Date() - cleanToDStoreTime > diffTime) {
      dispatch(setCleanToDStoreVisible(true));
      return;
    }

    // 关闭时统计 正在下载中正在安装中应用个数
    softs.forEach(soft => {
      if (soft.attr.status === 'dl' || soft.attr.status === 'pause') {
        downloadSofts.push(soft.apk && soft.apk.pkg ? soft.apk.pkg : soft.pc ? soft.pc.SoftID : '');
      } else if (soft.status === 'i') {
        installSofts.push(soft.apk && soft.apk.pkg ? soft.apk.pkg : soft.pc ? soft.pc.SoftID : '');
      }
    });
    if ((downloadSofts && downloadSofts.length > 0) || SIMStatus === SIM_DOWNLOAD_ING) {
      PCStoreJsBridge.storeTrayGetIsCreate().then(res => {
        if (res?.succ && !res?.exist) {
          dispatch(setPinPopCloseVisible(true));
        } else {
          PCStoreJsBridge.checkPINExits()
            .then(res => {
              if (res.PIN) {
                // 是否勾选不再弹出
                // APP_VERSION
                const clientVersion = JSON.parse(localGetItem('START_INFO'));
                const localVersion = localGetItem('VERSION_NUM');
                if (!localVersion || localVersion !== clientVersion.ClientVersion) {
                  dispatch(setPinPopVisible(true));
                  localSetItem('VERSION_NUM', clientVersion.ClientVersion);
                } else {
                  dispatch(setPinPopVisible(true));
                }
              } else {
                closeWindowFunc();
              }
            })
            .catch(() => {
              closeWindowFunc();
            });
        }
      });
      return;
    }
    // 判断桌面图标是否已经存在
    PCStoreJsBridge.checkPINExits()
      .then(res => {
        if (res.PIN) {
          // 是否勾选不再弹出
          // APP_VERSION
          const clientVersion = JSON.parse(localGetItem('START_INFO'));
          const localVersion = localGetItem('VERSION_NUM');
          const showPinNoMore = localStorage.getItem(localKeys.SHOW_PIN_NO_MORE);
          if (!localVersion || localVersion !== clientVersion.ClientVersion) {
            dispatch(setPinPopVisible(true));
            localSetItem('VERSION_NUM', clientVersion.ClientVersion);
          } else {
            if (showPinNoMore === 'true') {
              // closeWindowFunc();
              // 处理是否创建托盘，是所有优先级最低。
              showStoreTrayDialog();
              return;
            }
            dispatch(setPinPopVisible(true));
          }
        } else {
          showStoreTrayDialog();
          //closeWindowFunc();
        }
      })
      .catch(() => {
        showStoreTrayDialog();
        //closeWindowFunc();
      });
  }, [dispatch, softs, SIMStatus, userInfo]);

  const showStoreTrayDialog = useCallback(() => {
    const trayIsShow = localGetItem('Store_Close_Tray_IsShow');
    try {
      let startInfo = JSON.parse(localStorage.getItem('START_INFO'));
      if (
        startInfo?.isDStore &&
        startInfo?.ClientVersion &&
        startInfo?.ClientVersion !== trayIsShow
      ) {
        // 判断是否已经创建托盘, 没有则调出弹框
        PCStoreJsBridge.storeTrayGetIsCreate().then(res => {
          if (res.succ && !res.exist) {
            localSetItem('Store_Close_Tray_IsShow', startInfo?.ClientVersion);
            dispatch(setTrayDialogVisible({ isShow: true }));
          } else {
            closeWindowFunc();
          }
        });
      } else {
        closeWindowFunc();
      }
    } catch (error) {
      closeWindowFunc();
    }
  }, []);

  const handleShowOrder = () => {
    history.push(`${CONTEXT}/ordercenter`);
  };

  const handleCloseTag = () => {
    // localSetItem('ORDER_TAG_88', 3);
    setOrderTag(false);
  };

  return (
    <div
      className={
        topImgVideo && topImgVideo.visible && !topImgVideo.isScrolled
          ? styles.operation_white
          : styles.operation
      }
    >
      {window.CallNativeMethod && <User />}
      {
        <a className="icon" onClick={toggleDownload} style={{ position: 'relative' }}>
          <DownloadAnimate />
        </a>
      }
      <a className="icon_order">
        <div className="hot_box" onClick={handleShowOrder}>
          <i className="iconfont icon-a-shangyi05px" />
        </div>
        {orderTag && (
          <div className="order_prompt">
            <span>订单中心搬家了</span>
            <i className="iconfont icon-task_cancel" onClick={handleCloseTag} />
          </div>
        )}
      </a>

      <a className="icon" onClick={handleMessage}>
        <div className="hot_box">
          {hot && [hot[1], hot[2], hot[4], hot[5]].indexOf('1') > -1 && <div className="hot" />}
          <i className="iconfont icon-opt_message" />
        </div>
      </a>
      <a className="icon" onClick={handleMenu}>
        <div className="hot_box">
          {isShowHot && <div className="hot" />}
          <i className="iconfont icon-opt_menu" />
        </div>
      </a>
      <a className="icon" onClick={handleMini}>
        <i className=" iconfont icon-opt_min" />
      </a>
      {window.PcstoreCanChangeSize && isMaximize && (
        <a className="icon" onClick={handleMiddle}>
          <i className=" iconfont  icon-opt_mid" />
        </a>
      )}
      {window.PcstoreCanChangeSize && !isMaximize && (
        <a className="icon" onClick={handleMaximize}>
          <i className=" iconfont  icon-opt_big" />
        </a>
      )}
      <a className="icon" onClick={handleClose}>
        <i className="iconfont icon-opt_close" />
      </a>
    </div>
  );
});
